<template>
  <div>
    <!-- Header -->
    <div class="row mt-2">
      <!-- Items per page -->
      <div class="col-sm-12 col-md-6">
        <div class="row align-items-center">
          <div class="col-2 m-0">Mostrar&nbsp;</div>
          <div class="col-3 m-0 p-0">
            <b-form-select
              v-model="perPage"
              size="sm"
              :options="[20, 50, 100]"
            ></b-form-select>
          </div>
          <div class="col-3 m-0 p-0">&nbsp;por página</div>
        </div>
      </div>

      <!-- Search -->
      <div class="col-sm-12 col-md-6">
        <div id="tickets-table_filter" class="dataTables_filter text-md-right">
          <label class="d-inline-flex align-items-center">
            <b-form-input
              v-model="filter"
              type="search"
              placeholder="Pesquisar..."
              class="form-control form-control-sm ml-2"
            ></b-form-input>
          </label>
        </div>
      </div>

      <!-- New Banner -->
      <div class="col-md-12 mb-3 mt-2 d-flex justify-content-end">
        <b-dropdown variant="primary" right text="Novo Banner">
          <b-dropdown-item @click="openNewBanner('sales')">Novo banner Sales</b-dropdown-item>
          <b-dropdown-item @click="openNewBanner('greenn')">Novo banner Greenn</b-dropdown-item>
        </b-dropdown>
      </div>
    </div>

    <!-- Greenn Table -->
    <div class="row">
      <div class="col-12">
        <div v-if="banners.length > 0 && !loading" class="table-responsive mb-0">
          <b-table
            :items="banners"
            :fields="fields"
            responsive="sm"
            sort-by.sync="name"
            :sort-desc.sync="sortDesc"
            sort-icon-left
            :filter-included-fields="[]"
          >
            <!-- Name -->
            <template v-slot:cell(image_name)="data">
              {{ data.value }}
            </template>
            <!-- Origin -->
            <template v-slot:cell(origin)="data">
              {{ data.value }}
            </template>
            <!-- Order -->
            <template v-slot:cell(order)="data">
              <span v-if="data.item.source !== 'sales'">-</span>
              <span v-else>{{ data.value }}</span>
            </template>
            <!-- Status -->
            <template v-slot:cell(ativo)="data">
              <span v-if="data.item.source === 'sales'">-</span>
              <span v-else>{{ data.value ? 'ativo' : 'não ativo' }}</span>
            </template>
            <!-- Creation Date -->
            <template v-slot:cell(created_at)="data">
              <span v-if="!data.value">-</span>
              <span v-else>{{ data.value | datetime }}</span>
            </template>
            <!-- Actions -->
            <template v-slot:cell(_actions)="data">
              <div class="actions">
                <!-- Activate Banner -->
                <b-button
                  v-if="!data.item.ativo && data.item.source !== 'sales'"
                  v-b-tooltip.hover.left="'Ativar banner'"
                  variant="success"
                  @click="turnBannerOn(data.item)"
                >
                  <i class="fas fa-check"></i>
                </b-button>
                <!-- Delete Banner -->
                <b-button
                  v-if="data.item.source === 'sales' || !data.item.ativo"
                  v-b-tooltip.hover.left="'Deletar banner'"
                  variant="danger"
                  @click="data.item.source === 'sales' ? deleteSalesBanner(data.item) : deleteBanner(data.item)"
                >
                  <i class="fas fa-trash"></i>
                </b-button>
                <!-- Show Banner -->
                <b-button
                  v-b-tooltip.hover.left="'Visualizar informações do banner'"
                  variant="dark"
                  @click="openBannerDetails(data.item)"
                >
                  <i class="fas fa-info"></i>
                </b-button>
              </div>
            </template>
          </b-table>
        </div>
      </div>
    </div>

    <!-- Loading -->
    <div v-if="loading" class="row justify-content-center">
      <div class="spinner-border" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>

    <!-- Pagination -->
    <div v-if="banners.length > 0" class="row">
      <div class="col">
        <div class="dataTables_paginate paging_simple_numbers float-right">
          <ul class="pagination pagination-rounded mb-0">
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
            ></b-pagination>
          </ul>
        </div>
      </div>
    </div>
    
    <!-- Feedback Message -->
    <div v-if="banners.length === 0 && !loading" class="row justify-content-center">
      <div class="alert alert-primary" role="alert">
        Sem banners encontrados.
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import _ from 'lodash'
import { mapGetters } from 'vuex'

export default {
  name: 'TableGreenn',
  data() {
    return {
      sortDesc: false,
      fields: [
        { key: 'id', label: 'ID', sortable: true },
        { key: 'image_name', label: 'Nome do banner', sortable: true },
        { key: 'origin', label: 'Origem do Banner', sortable: true },
        { key: 'order', label: 'Ordem', sortable: true },
        { key: 'ativo', label: 'Status', sortable: false },
        { key: 'created_at', label: 'Data de Criação', sortable: false },
        { key: '_actions', label: 'Ações', sortable: false },
      ],
    }
  },
  computed: {
    ...mapGetters({
      banners: 'getBanners',
      loading: 'getLoading',
      totalRows: 'getTotalRows',
    }),
    filter: {
      get() {
        return this.$store.getters.getFilter
      },
      set(value) {
        this.$store.dispatch('updateFilter', value)
          .then(() => this.debounce())
      }
    },
    perPage: {
      get() {
        return this.$store.getters.getPerPage
      },
      set(value) {
        this.$store.dispatch('updatePerPage', value)
          .then(() => this.fetchBanners())
      }
    },
    currentPage: {
      get() {
        return this.$store.getters.getCurrentPage
      },
      set(value) {
        this.$store.dispatch('updateCurrentPage', value)
          .then(() => this.fetchBanners())
      }
    }
  },
  mounted() {
    this.fetchBanners()
  },
  methods: {
    debounce: _.debounce(function () {
      this.fetchBanners()
    }, 500),

    openNewBanner(target) {
      this.$emit('open-new-banner', { new: true, target })
    },
    openBannerDetails(item) {
      if (item.source === 'sales') {
        this.$emit('open-sales-banner-details', item.id)
        return
      }
      this.$emit('open-banner-details', item.id)
    },
    fetchBanners(filters = {}) {
      this.$store.dispatch('fetchBanners', filters)
    },
    turnBannerOn({id}) {
      Vue.swal({
        title: 'Ativar Banner?',
        text: 'Isto irá desativar outro banner que tiver ativo',
        type: 'success',
        showCancelButton: true,
        confirmButtonText: 'Ok',
        cancelButtonText: 'Cancelar',
        confirmButtonClass: 'btn btn-warning mt-2 mr-2',
        cancelButtonClass: 'btn btn-info mt-2',
        buttonsStyling: false,
      })
      .then((result) => {
        if(result.dismiss !== 'cancel') {
          this.$store.dispatch('activateBanner', id)
            .then(() => {
              this.$bvToast.toast('o banner foi ativado com sucesso!', {
                variant: 'success',
                title: 'Banner ativado!',
                autoHideDelay: 5000,
              })
              this.$bvModal.hide('details')
            })
        }
      })
    },
    turnBannerOff({id}) {
      Vue.swal({
        title: 'Desativar Banner?',
        text: 'Deve haver pelo menos 1 banner ativo',
        showCancelButton: true,
        confirmButtonText: 'Reprovar',
        cancelButtonText: 'Cancelar',
        showLoaderOnConfirm: true,
        allowOutsideClick: false,
      })
      .then((result) => {
        if(result.value) {
          this.$store.dispatch('deactivateBanner', id)
            .then(() => {
              this.$bvToast.toast('o banner foi desativado com sucesso!', {
                variant: 'success',
                title: 'Banner desativado!',
                autoHideDelay: 5000,
              })
              this.$bvModal.hide('details')
            })
        }
      })
    },
    deleteBanner(dados) {
      Vue.swal({
        title: 'Apagar Banner?',
        text: 'este ação é irreversível',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Apagar',
        cancelButtonText: 'Cancelar',
        showLoaderOnConfirm: true,
        allowOutsideClick: false,
      })
      .then((result) => {
        if(result.value) {
          this.$store.dispatch('deleteBanner', dados)
            .then(() => {
              this.$bvToast.toast('o banner foi apagado com sucesso!', {
                variant: 'success',
                title: 'Banner apagado!',
                autoHideDelay: 5000,
              })
              this.$bvModal.hide('details')
            })
            .catch(() => {
              this.$bvToast.toast('Nao foi possivel apagar o banner.', {
                variant: 'danger',
                title: 'Erro ao apagar',
                autoHideDelay: 5000,
              })
            })
        }
      })
    },
    deleteSalesBanner({ id }) {
      Vue.swal({
        title: 'Apagar Banner?',
        text: 'este ação é irreversível',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Apagar',
        cancelButtonText: 'Cancelar',
        showLoaderOnConfirm: true,
        allowOutsideClick: false,
      })
      .then((result) => {
        if(result.value) {
          this.$store.dispatch('deleteSalesBanner', id)
            .then(() => {
              this.$bvToast.toast('o banner foi apagado com sucesso!', {
                variant: 'success',
                title: 'Banner apagado!',
                autoHideDelay: 5000,
              })
              this.$bvModal.hide('details-sales-view')
            })
            .catch(() => {
              this.$bvToast.toast('Nao foi possivel apagar o banner.', {
                variant: 'danger',
                title: 'Erro ao apagar',
                autoHideDelay: 5000,
              })
            })
        }
      })
    },
  }
}
</script>
